module.exports = __webpack_public_path__ + "img/bn.2e6202db.jpg";